export default __webpack_public_path__ + "file/Brochure-Puroak-ES.asset.f3ce6792.pdf";